import { Nutrients } from '@cf-shared/data-model/food';

/**
 * Drop the nutrients a person has just cleared from a typed-in food's map.
 *
 * Each nutrient field on the amount screen writes straight into the food's map, and an
 * emptied field writes `undefined` (df-9f90ca4b1f6c). The scaling helpers rightly call
 * `undefined` damaged when it comes from the database, so leaving it in the map reported
 * every cleared field to Sentry as a damaged stored value. An absent key means the same as
 * the cleared field: nothing entered. It still shows as "--", adds nothing to a total, and
 * is what the saved food ends up with anyway, because saving drops `undefined`.
 *
 * Only `undefined` goes. `null` is the stored "not measured" value and stays, and so does
 * anything else, so a value that really is damaged is still there to be reported.
 */
export function dropClearedNutrientInputs(nutrients: Nutrients | undefined): void {
  // if the food has no map at all there is nothing to clear
  if (!nutrients) return;

  for (const nutrientKey of Object.keys(nutrients)) {
    if (nutrients[nutrientKey] === undefined) {
      delete nutrients[nutrientKey];
    }
  }
}
